import { useMemo } from "react";
import { VEHICLE_TYPES, VEHICLE_TYPES_COLORS } from "./constants";
import { scaleOrdinal } from "d3-scale";

export const formatNumber = (value: number | string) =>
  typeof value === "string" ? value : Intl.NumberFormat().format(value);

export const formatNumberThousands = (value: number | string) => {
  const numValue = Number(value);
  const formatter = Intl.NumberFormat(undefined, {
    notation: "compact",
    maximumFractionDigits: 1,
  });
  return formatter.format(numValue);
};

export const useTrafficCountColorAccessor = () => {
  const colorRange = VEHICLE_TYPES.map(
    (vehicleType) => VEHICLE_TYPES_COLORS[vehicleType as keyof typeof VEHICLE_TYPES_COLORS]
  );

  return useMemo(() => {
    return scaleOrdinal<string>().domain(VEHICLE_TYPES).range(colorRange).unknown("#999");
  }, [colorRange]);
};
